/* eslint-disable no-unused-expressions */
import "../scss/faq.scss";
import { $Q, $Qll } from '../utils/query-selector';

const categoriesMenu = $Q('.categories-menu');
const categoriesMenuItems = $Qll('.categories-menu__item');
const categoriesMenuTitle = $Q('.categories-menu__title');
const categoriesblocks = $Qll('.categories-container');

/**
 * This function is responsible for cleaning all the categories of the menu
 */
 const cleanCategories = () => {
  categoriesMenuItems.forEach((e) => {
    e.classList.remove('isClicked');
  });
}

/**
 * This function is responsible for displaying all the FAQ blocks
 */
 const showAllBlocks = () => {
  categoriesMenuTitle.addEventListener('click', () => {
    cleanCategories();
    categoriesblocks.forEach((block) => {
      // eslint-disable-next-line no-param-reassign
      block.parentNode.style.display = 'block';
    });
  });
}

/**
 * This function takes care of adding a class to the clicked element
 *
 * @param {*} e Event of one of the items in the category menu
 */
 const categoryClicked = (e) => {
  e.target.classList.contains('categories-menu__item')
    ? e.target.classList.add('isClicked')
    : e.target.parentNode.classList.add('isClicked');
}

/**
 * This function is responsible for showing or hiding the FAQ blocks
 *
 * @param {Event} e Event of one of the items in the category menu
 */
 const showOrHideBlock = (e) => {
  cleanCategories();
  categoryClicked(e);
  // eslint-disable-next-line prefer-const
  let dataHandle = e.target.classList.contains('categories-menu__item')
    ? e.target.dataset.handle
    : e.target.parentNode.dataset.handle;

  categoriesblocks.forEach((block) => {
    block.dataset.handle === dataHandle
      // eslint-disable-next-line no-param-reassign
      ? block.parentNode.style.display = 'block'
      // eslint-disable-next-line no-param-reassign
      : block.parentNode.style.display = 'none';
  });
}

/**
 * Start the event for the categories menu
 */
const initEventCategory = () => {
  if (!categoriesMenu) return;
  categoriesMenuItems.forEach((item) => {
    item.addEventListener('click', showOrHideBlock);
  });

  showAllBlocks();
}

initEventCategory();
